export default "assets/images/icons/chevron-0d02ff65.svg";